import React from 'react';

const BtnSubmit = (props) => {
  let className = props?.isBusiness
      ? 'btn-submit-purple'
      : 'btn-submit';
  if (props.className) {
    className += ' ' + props.className;
  }

  return (
    <button
      id='btnSubmit'
      type={props.type ?? 'submit'}
      className={className}
      form={props?.formid}
      onClick={props?.onclick}
      disabled={props?.disabled} 
      style={props?.backgroundColor ? { background: props?.backgroundColor } : null}>
      {props?.isDisplayWhatsAppIcon && <span className='whatsapp-icon'></span>}
      <span htmlFor='btnSubmit' className='btn-submit__label' style={props?.color ? { color: props?.color } : null}>
        {props?.text}
      </span>
      {props?.isDisplayArrows && <span className='arrows-icon'></span>}
    </button>
  );
};

export default BtnSubmit;
